export default "__VITE_ASSET__e5f739c0__"